import "idempotent-babel-polyfill";
import Vue from "vue";
import { abbreviateNumber } from "../lib/abbreviateNumber.mjs";

function pluralize(count, noun, suffix = "s") {
  return `${count} ${noun}${count !== 1 ? suffix : ""}`;
}

function capitalize(value) {
  if (!value) return "";
  return value.toString().charAt(0).toUpperCase() + value.slice(1);
}

function humanize(value) {
  var arr = value.split(/[_-]/);
  var newStr = "";
  for (var i = 1; i < arr.length; i++) {
    newStr += " " + arr[i].charAt(0) + arr[i].slice(1);
  }
  return capitalize(arr[0] + newStr);
}

function toCamelCase(value) {
  var arr = value.split(/[_-]/);
  var newStr = "";
  for (var i = 1; i < arr.length; i++) {
    newStr += arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  }
  return arr[0] + newStr;
}

Vue.filter("pluralize", pluralize);
Vue.filter("capitalize", capitalize);
Vue.filter("humanize", humanize);
Vue.filter("abbreviateNumber", abbreviateNumber);
Vue.filter("toCamelCase", toCamelCase);

Vue.filter("formatDateTime", (value) => {
  if (!value) return "";
  return window.moment(value).format("MM/DD/YY h:mma");
});

Vue.filter("formatDate", (value) => {
  if (!value) return "";
  // return window.moment(value).format("MM/DD/YY");
  return window.moment(value).calendar(window.moment(), {
    lastDay: "[Yesterday]",
    sameDay: "[Today]",
    nextDay: "[Tomorrow]",
    lastWeek: "L",
    nextWeek: "MMM D",
    sameElse: "L",
  });
});

Vue.filter("truncate", function (value, limit) {
  let truncated = value || "";
  if (value.length > limit) {
    truncated = value.substring(0, limit - 3) + "...";
  }
  return truncated;
});
